import styled from 'styled-components';

export const EntInfosContainer = styled.div`
    width: 100%;
    font-size: 0.9rem;
    margin-top: 0.5rem;
`;

export const EIFormCol = styled.div`
     width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
          @media (max-width: ${({ theme }) => theme.size.laptopL}) {
   flex-direction: column;
  }
`

export const EIFormColInfo = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column; 
    @media (max-width: ${({ theme }) => theme.size.laptopL}) {
   width: 100%;
  }

`

export const EIFormCol2 = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
  
`

export const EIContainer = styled.div`
    width: 100%;
    display: flex;
    height:fit-content ;
    border: 1px solid ${({ theme, border }) => (border ? border : theme.colors.gray)};
    border-radius: 12px;
    //justify-content: space-between;
    align-items: flex-start;
    padding: 10px;
       flex-direction: column;
        min-height: ${({ minHeight }) => minHeight ? minHeight : 'auto'};

`;

export const FormGroup = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 0.25rem;
 
     border-bottom: 1.5px solid ${({ theme }) => theme.colors.borderGray};;

  &:not(:last-child) {
    margin-bottom: 0.75rem;


  }

  &.fadeOut {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 300ms, opacity 300ms;
  }

  &.fadeIn {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 300ms;
  }
  
`;